module.exports = __webpack_public_path__ + "static/media/as.23e6ae7d.svg";